import { createApp } from 'vue'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookieAcceptDecline from 'vue-cookie-accept-decline';
import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css';



import '@fontsource/rubik/300.css'
import '@fontsource/rubik/400.css'
import '@fontsource/rubik/500.css'
import '@fontsource/rubik/600.css'
import '@fontsource/rubik/700.css'
import '@fontsource/rubik/800.css'

/* optional italic styles */
import '@fontsource/roboto/100-italic.css'
import '@fontsource/roboto/300-italic.css'
import '@fontsource/roboto/400-italic.css'
import '@fontsource/roboto/500-italic.css'
import '@fontsource/roboto/700-italic.css'
import '@fontsource/roboto/900-italic.css'
import '@mdi/font/css/materialdesignicons.css'
import './assets/style.css'

// Components
import App from './App.vue'


const vuetify = createVuetify({
    components,
    directives,
    theme: {
        defaultTheme: 'light',
        themes: {
            light: {
                colors: {
                    primary: '#ee3d4b',
                    secondary: '#323232',
                    accent: '#b5b4b4',
                }
            }
        }
    },
    defaults: {
    global: {
      style: {
        fontFamily: 'Rubik'
      }
    }
  }
})



createApp(App)
    .use(router)
    .use(vuetify)
    .use(VueAxios, axios)
    .component('vue-cookie-accept-decline', VueCookieAcceptDecline)
    .mount('#app')

